export const es = {
  nav: {
    home: "Inicio",
    adult: "Adulto",
    kids: "Kids",
    radar: "Radar",
    partners: "Aliados",
    scheduleTrial: "Agendar clase de prueba",
  },
  footer: {
    tagline: "El liderazgo no se improvisa, se entrena.",
    copyright: "© 2026 Vagner Lima",
    privacy: "Política de Privacidad",
    terms: "Términos de Uso",
    dataDeletion: "Eliminación de Datos",
  },
  contactBanner: {
    kids: {
      eyebrow: "DA EL PRIMER PASO",
      title: "El liderazgo comienza en la infancia.",
      description: "Conversa con el profesor y descubre cómo el Jiu-Jitsu potencia el carácter y la confianza de tu hijo.",
      cta: "Agendar clase de prueba para mi hijo",
    },
    adult: {
      eyebrow: "VIVE LA EXPERIENCIA",
      title: "Tu próxima decisión estratégica comienza en el tatami.",
      description: "Descubre una experiencia ejecutiva que conecta los desafíos del tatami con las decisiones de liderazgo.",
      cta: "Conversar sobre clases privadas y experiencias",
    },
  },
  home: {
    hero: {
      eyebrow: "UNA METODOLOGÍA • DOS JORNADAS",
      title: "El liderazgo no se improvisa, se entrena.",
      subtitle: "Jiu-Jitsu, liderazgo y mundo corporativo unidos en una metodología para adultos, empresas y niños.",
      chooseMethod: "Elige tu metodología",
      howToParticipate: "Cómo participar →",
      photoLabel: "PROFESOR • CINTURÓN NEGRO",
    },
    journeys: {
      eyebrow: "ELIGE TU CAMINO",
      title: "Dos jornadas. El mismo propósito.",
      subtitle: "Selecciona la metodología que deseas conocer.",
      adult: {
        tag: "PARA ADULTOS, LÍDERES Y EMPRESARIOS",
        title: "Executive Jiu-Jitsu",
        desc: "Estrategia, autocontrol y toma de decisiones bajo presión.",
        cta: "CONOCER METODOLOGÍA ADULTO →",
      },
      kids: {
        tag: "PARA NIÑOS Y SUS FAMILIAS",
        title: "Executive Jiu-Jitsu Kids",
        desc: "Respeto, confianza y liderazgo desde la infancia.",
        cta: "CONOCER METODOLOGÍA KIDS →",
      },
    },
    bridge: {
      eyebrow: "JIU-JITSU + MUNDO CORPORATIVO",
      title: "Lo que sucede en el tatami no termina en el tatami.",
      p1: "Presión, estrategia, adaptación, control emocional y decisión forman parte tanto del Jiu-Jitsu como de la rutina de quienes lideran empresas.",
      p2: "Executive Jiu-Jitsu transforma situaciones vividas en el entrenamiento en reflexiones prácticas para los negocios, la familia y la vida.",
      step1: "01 VIVIR",
      step2: "02 COMPRENDER",
      step3: "03 APLICAR",
    },
    participation: {
      eyebrow: "ENCUENTRA LA EXPERIENCIA ADECUADA",
      title: "Cómo participar. Elige tu camino.",
      subtitle: "Una propuesta para cada objetivo, siempre con el acompañamiento del profesor Vagner Lima.",
      card1: {
        tag: "01 · INDIVIDUAL",
        title: "Clases privadas",
        desc: "Una experiencia personalizada para adultos que buscan desarrollo técnico, estrategia y evolución a su propio ritmo.",
        cta: "CONSULTAR DISPONIBILIDAD →",
      },
      card2: {
        tag: "02 · LIDERAZGO",
        title: "Grupos ejecutivos",
        desc: "Vivencias que conectan el Jiu-Jitsu a los desafíos de líderes, empresarios y profesionales en crecimiento.",
        cta: "CONOCER LA PROPUESTA →",
      },
      card3: {
        tag: "03 · EMPRESAS",
        title: "Experiencias corporativas",
        desc: "Lleva a tu equipo una reflexión práctica sobre liderazgo, comunicación, presión y toma de decisiones.",
        cta: "HABLAR DE MI EMPRESA →",
      },
      card4: {
        tag: "04 · INFANCIA",
        title: "Clases Kids",
        desc: "Disciplina, respeto, confianza y responsabilidad en una experiencia pensada para la formación de los niños.",
        cta: "CONOCER EXECUTIVE KIDS →",
      },
      schedule: {
        adultTitle: "ADULTO",
        adultTime: "Lunes, miércoles y viernes · 19:00 y 21:15",
        kidsTitle: "KIDS",
        kidsTime: "Lunes, miércoles y viernes · 10:00 y 14:00",
        locationTitle: "DÓNDE",
        locationAddress: "CT Haseyo · Rua Francisco Jacinto de Melo, 1277",
      },
    },
    beyond: {
      eyebrow: "MÁS ALLÁ DEL TATAMI",
      title: "El aprendizaje continúa fuera del entrenamiento.",
      subtitle: "La experiencia se conecta con los desafíos reales del liderazgo y de la vida diaria.",
      feature1Title: "Desafíos de liderazgo",
      feature1Desc: "El aprendizaje aplicado a la rutina profesional y personal.",
      feature2Title: "Evolución continua",
      feature2Desc: "Consistencia, metas alcanzadas y desarrollo individual.",
      feature3Title: "Radar Ejecutivo",
      feature3Desc: "Mercado, economía y negocios para quienes necesitan decidir.",
      cta: "Acceder al Radar Ejecutivo →",
    },
    radarPreview: {
      eyebrow: "CONTENIDO PARA QUIENES DECIDEN",
      title: "Radar Ejecutivo. Información con aplicación práctica.",
      subtitle: "Una selección pensada para conectar lo que ocurre en el mercado con las decisiones de líderes y empresarios.",
      card1Tag: "ECONOMÍA",
      card1Title: "Escenario económico",
      card1Desc: "Movimientos que influyen en costos, demanda, crédito y planificación.",
      card2Tag: "FINANZAS",
      card2Title: "Decisiones financieras",
      card2Desc: "Información relevante para tesorería, inversiones y gestión de riesgos.",
      card3Tag: "LIDERAZGO",
      card3Title: "Visión Executive",
      card3Desc: "La lectura práctica: ¿cómo impacta esto en tu empresa y decisiones?",
      cta: "Explorar el Radar Ejecutivo →",
    },
    partnersPreview: {
      eyebrow: "CONEXIONES QUE GENERAN OPORTUNIDADES",
      title: "Alianzas estratégicas. Los negocios también se construyen juntos.",
      subtitle: "Empresas y profesionales conectados al universo del liderazgo, las finanzas y el desarrollo personal.",
      cta: "Conocer empresas aliadas",
      cardTag: "ALIADO EXECUTIVE · CONSORCIOS",
      cardDesc: "Planificación para la adquisición de inmuebles, vehículos y construcción patrimonial.",
      cardCta: "CONOCER ALIANZA →",
    },
    professor: {
      eyebrow: "QUIEN DIRIGE LA EXPERIENCIA",
      name: "Vagner Lima",
      subtitle: "Del mercado financiero al tatami.",
      desc: "Profesor cinturón negro de Jiu-Jitsu y profesional con más de 14 años de experiencia en el mercado financiero, Vagner une estrategia, desarrollo humano y vivencia práctica en una metodología propia.",
      badge1Num: "14+",
      badge1Text: "AÑOS EN EL MERCADO FINANCIERO",
      badge2Num: "CINTURÓN NEGRO",
      badge2Text: "PROFESOR DE JIU-JITSU",
      quote: "“El tatami transforma principios en experiencias para la vida.”",
      cta: "Conversar con el profesor",
    },
  },
  adult: {
    hero: {
      eyebrow: "METODOLOGÍA ADULTO",
      title: "El tatami enseña. El liderazgo transforma.",
      subtitle: "Una experiencia que conecta los principios del Jiu-Jitsu con los desafíos reales de quienes lideran, emprenden y deciden bajo presión.",
      cta: "Conoce la propuesta",
    },
    editorial: {
      eyebrow: "EXECUTIVE JIU-JITSU",
      title: "No se trata de formar luchadores. Se trata de forjar líderes.",
      p1: "En el entorno corporativo, las decisiones clave rara vez llegan en condiciones perfectas. Hay presión, incertidumbre, riesgo y poco tiempo.",
      p2: "En el tatami, el alumno vive situaciones que estimulan el control emocional, la lectura de escenarios, la adaptación y la toma de decisiones.",
      step1Title: "Experiencia",
      step1Desc: "El principio se vive en una situación real y controlada de entrenamiento.",
      step2Title: "Reflexión",
      step2Desc: "El alumno reconoce su reacción, sus elecciones y los resultados.",
      step3Title: "Aplicación",
      step3Desc: "El aprendizaje se conecta con los desafíos del liderazgo y los negocios.",
    },
    corporatePhoto: {
      eyebrow: "DEL CORPORATIVO AL TATAMI",
      title: "Experiencia de mercado. Vivencia real en Jiu-Jitsu.",
      p1: "Executive Jiu-Jitsu nace de la unión entre dos entornos que exigen preparación: el mundo de los negocios y el tatami.",
      p2: "Metas, negociación, riesgo, presión y relaciones encuentran disciplina, estrategia, apalancamiento y control emocional.",
      quote: "“No se trata de transformar ejecutivos en luchadores. Se trata de entrenar líderes.”",
    },
    principles: {
      eyebrow: "LA ESENCIA DE LA METODOLOGÍA",
      title: "10 principios. Un liderazgo más preparado.",
      viewMore: "CONOCER LOS OTROS CINCO PRINCIPIOS",
      items: [
        { num: "01", title: "Estabilidad", desc: "Construir una base sólida para decidir con seguridad." },
        { num: "02", title: "Adaptación", desc: "Encontrar posibilidades incluso en escenarios desfavorables." },
        { num: "03", title: "Conexión", desc: "Fortalecer relaciones, escucha activa e influencia positiva." },
        { num: "04", title: "Estrategia", desc: "Transformar movimiento en avance con claridad y método." },
        { num: "05", title: "Control", desc: "Consolidar antes de acelerar y actuar con conciencia." },
        { num: "06", title: "Sustentación", desc: "Mantener resultados a través de consistencia y equilibrio." },
        { num: "07", title: "Reacción", desc: "Responder a desafíos con inteligencia y resiliencia." },
        { num: "08", title: "Presión", desc: "Conducir situaciones difíciles con propósito y autocontrol." },
        { num: "09", title: "Oportunidad", desc: "Reconocer los caminos creados por la preparación." },
        { num: "10", title: "Ejecución", desc: "Transformar buenas decisiones en resultados concretos." },
      ],
    },
    benefits: {
      eyebrow: "A QUIÉN VA DIRIGIDO",
      title: "Para quienes lideran personas, negocios y decisiones.",
      audiences: [
        "Empresarios y emprendedores",
        "Ejecutivos y gerentes",
        "Profesionales de alto rendimiento",
        "Adultos en busca de superación personal",
      ],
    },
    formats: {
      eyebrow: "CÓMO PARTICIPAR",
      title: "Una experiencia. Diferentes posibilidades.",
      card1Title: "Clases privadas",
      card1Desc: "Atención individual y desarrollo a tu propio ritmo.",
      card2Title: "Grupos ejecutivos",
      card2Desc: "Jiu-Jitsu y liderazgo para profesionales y empresarios.",
      card3Title: "Experiencias corporativas",
      card3Desc: "Una propuesta para equipos, empresas y desarrollo de líderes.",
      cta: "Encontrar la mejor experiencia para mí",
    },
    ecosystem: {
      eyebrow: "UN ECOSISTEMA DE DESARROLLO",
      title: "Entrenar. Reflexionar. Evolucionar continuamente.",
      subtitle: "La propuesta conecta el entrenamiento presencial con desafíos de liderazgo, seguimiento de progreso e inteligencia de mercado.",
      card1Title: "Tatami",
      card1Desc: "Experiencia práctica, presión controlada y toma de decisiones.",
      card2Title: "Desafíos",
      card2Desc: "El aprendizaje llevado a situaciones reales de la rutina empresarial.",
      card3Title: "Evolución",
      card3Desc: "Registro objetivo de horas, técnicas y logros personales.",
      card4Title: "Radar",
      card4Desc: "Economía, finanzas, negocios y liderazgo con contexto.",
    },
  },
  kids: {
    hero: {
      eyebrow: "EXECUTIVE JIU-JITSU KIDS",
      title: "Líderes en el Tatami.",
      subtitle: "Más que aprender movimientos: desarrollar confianza, valores y actitudes que acompañan al niño dentro y fuera del tatami.",
      cta: "Conoce la metodología",
      badge: "FORMANDO LÍDERES DESDE LA INFANCIA",
    },
    editorial: {
      eyebrow: "LO QUE TU HIJO VA A DESARROLLAR",
      title: "La confianza comienza en el tatami. Y acompaña al niño toda la vida.",
      p1: "La metodología Líderes en el Tatami utiliza el Jiu-Jitsu como herramienta de desarrollo físico, emocional y social, respetando la edad y el ritmo de cada niño.",
      p2: "A través de desafíos apropiados para la infancia, cultivamos actitudes que se reflejan en el hogar, la escuela y la convivencia.",
    },
    pillars: {
      eyebrow: "CINCO PILARES DE FORMACIÓN",
      title: "Pequeños en tamaño. Grandes en actitud.",
      items: [
        { num: "01", title: "Respeto", desc: "Aprender a escuchar, esperar el turno y tratar a los demás con cuidado." },
        { num: "02", title: "Autocontrol", desc: "Reconocer emociones, calibrar la fuerza y pensar antes de actuar." },
        { num: "03", title: "Coraje", desc: "Afrontar nuevos retos y perseverar ante las dificultades iniciales." },
        { num: "04", title: "Cooperación", desc: "Ayudar, compartir logros y comprender el valor del grupo." },
        { num: "05", title: "Responsabilidad", desc: "Cuidar las propias actitudes, el espacio compartido y a los demás." },
      ],
      promiseTitle: "Cada niño evoluciona a su propio ritmo natural.",
      promiseSubtitle: "Sin clasificaciones públicas, etiquetas ni comparaciones.",
    },
    family: {
      eyebrow: "LO QUE LOS PADRES PUEDEN ESPERAR",
      title: "Una formación que va más allá de la técnica.",
      benefit1Title: "Mayor confianza",
      benefit1Desc: "El niño aprende a reconocer sus logros y enfrentar desafíos con seguridad.",
      benefit2Title: "Equilibrio emocional",
      benefit2Desc: "Desarrolla la capacidad de comprender sentimientos y responder con más conciencia.",
      benefit3Title: "Mejor convivencia",
      benefit3Desc: "Fortalece el respeto, la cooperación y las actitudes positivas.",
      benefit4Title: "Familia presente",
      benefit4Desc: "Las lecciones del tatami se integran con los valores del hogar.",
    },
    schedule: {
      eyebrow: "HORARIOS Y LOCALIZACIÓN",
      title: "El primer logro comienza con el primer paso.",
      whenTitle: "CUÁNDO",
      whenDesc: "Lunes, miércoles y viernes",
      whenHours: "10:00 y 14:00",
      whereTitle: "DÓNDE",
      wherePlace: "CT Haseyo",
      whereAddress: "Rua Francisco Jacinto de Melo, 1277",
    },
  },
  radar: {
    hero: {
      eyebrow: "RADAR EJECUTIVO",
      title: "Noticias para quienes necesitan decidir.",
      subtitle: "Mercado financiero, liderazgo, empresas, economía y negocios reunidos en un solo lugar — siempre con contexto corporativo.",
      liveNews: "NOTICIAS ACTUALIZADAS AUTOMÁTICAMENTE",
      editorialSources: "CURADURÍA DE FUENTES PARA EL MUNDO CORPORATIVO",
    },
    orbit: {
      mercado: "MERCADO",
      financas: "FINANZAS",
      empresas: "EMPRESAS",
      lideranca: "LIDERAZGO",
      negocios: "NEGOCIOS",
    },
    newsArea: {
      eyebrow: "OCURRE AHORA",
      title: "El mundo en movimiento. Tu estrategia también.",
      liveSubtitle: "Noticias recientes reunidas de diferentes medios, con contexto para quienes lideran.",
      editorialSubtitle: "Accede directamente a fuentes confiables y sigue los temas que influyen en las decisiones empresariales.",
      lastUpdate: "Última actualización:",
      recentUpdate: "Actualización reciente",
      selectedSources: "FUENTES SELECCIONADAS",
      newsCount: "{{count}} NOTICIAS",
      sourcePrefix: "Fuente:",
      executiveView: "VISIÓN EXECUTIVE",
      readFull: "LEER NOTICIA COMPLETA ↗",
      accessEditorial: "ACCEDER A LA FUENTE ↗",
    },
    method: {
      eyebrow: "MÁS QUE INFORMACIÓN",
      title: "Lee el escenario. Prepara la decisión.",
      step1Title: "Hecho",
      step1Desc: "Comprende objetivamente lo que ocurrió.",
      step2Title: "Contexto",
      step2Desc: "Reconoce riesgos, impactos y oportunidades de negocio.",
      step3Title: "Decisión",
      step3Desc: "Conecta la noticia a la realidad estratégica de tu empresa.",
    },
    cta: {
      eyebrow: "JIU-JITSU + MUNDO CORPORATIVO",
      title: "Conciencia antes de la acción. Estrategia antes de la fuerza.",
      button: "Conocer la metodología Adulto",
    },
  },
  partners: {
    hero: {
      eyebrow: "RED EXECUTIVE JIU-JITSU",
      title: "Conexiones acertadas. Oportunidades reales.",
      subtitle: "Una red de empresas y profesionales que comparten valores de confianza, estrategia y crecimiento.",
      cta: "Conocer a nuestros aliados",
      markTag: "EXECUTIVE",
      markTitle: "Conexiones & Negocios.",
      markSubtitle: "DEL TATAMI AL MUNDO CORPORATIVO",
    },
    intro: {
      eyebrow: "ALIANZAS ESTRATÉGICAS",
      title: "Más que recomendaciones. Relaciones construidas con confianza.",
      desc: "Executive Jiu-Jitsu conecta a empresarios, ejecutivos, familias y profesionales con empresas que aceleran objetivos corporativos y patrimoniales.",
    },
    showcase: {
      eyebrow: "ALIADOS EXECUTIVE",
      title: "Empresas que forman parte de nuestra red.",
      partnerTag: "ALIADO EXECUTIVE",
      category: "CONSORCIOS · PLANIFICACIÓN PATRIMONIAL",
      cardTitle: "Planificar hoy. Conquistar con estrategia.",
      cardDesc: "Soluciones en consorcios para quienes buscan planificar la adquisición de inmuebles, vehículos y patrimonio.",
      tag1: "Inmuebles",
      tag2: "Vehículos",
      tag3: "Planificación",
      cta: "Solicitar recomendación del aliado",
      disclosure: "Las empresas presentadas son responsables de los términos, condiciones y servicios ofrecidos. Consulta directamente para conocer cada propuesta.",
    },
    connectionAreas: {
      eyebrow: "UNA RED EN EXPANSIÓN",
      title: "Áreas que se conectan con tu universo.",
      items: [
        { num: "01", title: "Consorcios y patrimonio", desc: "Soluciones para planificación, adquisición de bienes y crecimiento patrimonial." },
        { num: "02", title: "Finanzas y negocios", desc: "Crédito, estructuración financiera y oportunidades comerciales." },
        { num: "03", title: "Asesoría empresarial", desc: "Apoyo legal, contable y estratégico para decisiones más seguras." },
        { num: "04", title: "Salud y rendimiento", desc: "Profesionales dedicados al bienestar, calidad de vida y longevidad ejecutiva." },
      ],
    },
    invitation: {
      eyebrow: "TU EMPRESA Y EXECUTIVE JIU-JITSU",
      title: "Buenas conexiones abren novos caminhos.",
      desc: "Si tu empresa comparte valores de excelencia, confianza y desarrollo, conversemos sobre una alianza.",
      cta: "Quero presentar mi empresa",
    },
  },
  legal: {
    badge: "CONFORMIDAD & TRANSPARENCIA",
    lastUpdated: "Última actualización: 28 de agosto de 2026",
    tabs: {
      privacy: "Política de Privacidad",
      terms: "Términos de Uso",
      dataDeletion: "Eliminación de Datos",
    },
    privacy: {
      title: "Política de Privacidad",
      subtitle: "Compromiso con la seguridad, privacidad y protección de sus datos personales conforme a la LGPD (Ley nº 13.709/2018), Google Play Console y Apple App Store.",
      sections: [
        {
          title: "1. Identificación del Responsable del Tratamiento",
          content: "Executive Jiu-Jitsu, bajo la dirección y supervisión técnica del Profesor Vagner Lima, actúa como responsable del tratamiento de los datos personales recopilados a través de nuestras aplicaciones móviles (Google Play y Apple App Store), plataformas digitales y canales de atención oficial.",
        },
        {
          title: "2. Datos Personales Recopilados",
          content: "Recopilamos únicamente los datos estrictamente necesarios para la prestación de nuestros servicios de entrenamiento, agendamiento de clases y gestión de alumnos:\n• Datos de contacto e identificación: Nombre completo, correo electrónico, teléfono (WhatsApp) y fecha de nacimiento.\n• Datos de perfil y asistencia: Graduación (cinturón), historial de asistencia, clases inscritas (Adulto/Kids) y agendamiento de clases de prueba.\n• Datos técnicos de uso: Identificadores anónimos de dispositivo, versión del sistema operativo y diagnósticos de estabilidad de la aplicación.",
        },
        {
          title: "3. Finalidad y Base Legal del Tratamiento",
          content: "Sus datos son tratados con base en las normativas aplicables de protección de datos:\n• Gestión de reservas de clases, check-in y control de asistencia.\n• Comunicación directa sobre avisos de entrenamientos, seminarios, graduaciones y notificaciones.\n• Soporte al usuario y mejora continua de la experiencia en la app.\n• Cumplimiento de obligaciones legales, fiscales y normativas aplicables.",
        },
        {
          title: "4. Compartición Segura de Datos",
          content: "Executive Jiu-Jitsu no vende, no alquila ni comercializa sus datos personales con terceros para fines publicitarios. La compartición se realiza exclusivamente con proveedores de infraestructura tecnológica indispensables (alojamiento en la nube cifrado, bases de datos seguras y envío de notificaciones push), bajo rigurosos acuerdos de confidencialidad.",
        },
        {
          title: "5. Seguridad y Almacenamiento",
          content: "Implementamos altos estándares de seguridad, incluyendo cifrado TLS/HTTPS en todas las comunicaciones, controles de acceso restringido y monitoreo continuo para prevenir accesos no autorizados o incidentes de seguridad.",
        },
        {
          title: "6. Derechos del Titular de los Datos",
          content: "Usted tiene garantizado el derecho a solicitar en cualquier momento:\n• Confirmación de la existencia de tratamiento y acceso a sus datos personales.\n• Rectificación de datos incompletos, inexactos o desactualizados.\n• Revocación del consentimiento otorgado previamente.\n• Anonimización, bloqueo o eliminación definitiva de sus datos personales.\n• Eliminación permanente de su cuenta y registros asociados.",
        },
        {
          title: "7. Contacto del Delegado de Protección de Datos (DPO)",
          content: "Para cualquier duda o requerimiento relacionado con sus datos personales, comuníquese directamente con nuestro equipo de privacidad a través del correo electrónico: contato@executivejiujitsu.com o por WhatsApp oficial al +55 (48) 99608-7396.",
        },
      ],
    },
    terms: {
      title: "Términos de Uso",
      subtitle: "Condiciones generales de navegación, uso de la aplicación móvil, reservas de clases y participación en las actividades de Executive Jiu-Jitsu.",
      sections: [
        {
          title: "1. Aceptación de los Términos",
          content: "Al descargar, instalar o utilizar la aplicación móvil y las plataformas digitales de Executive Jiu-Jitsu, usted declara haber leído, comprendido y aceptado en su totalidad estos Términos de Uso y nuestra Política de Privacidad.",
        },
        {
          title: "2. Registro y Uso de la Cuenta",
          content: "El usuario se compromete a proporcionar información verídica y actualizada al registrarse o agendar clases. El usuario es el único responsable de mantener la confidencialidade de sus credenciales de acceso.",
        },
        {
          title: "3. Aptitud Física y Salud",
          content: "El Jiu-Jitsu es un arte marcial de contacto que exige esfuerzo físico. El usuario (o su tutor legal, en el caso de Executive Kids) declara encontrarse en óptimas condiciones de salud para la práctica deportiva, recomendándose una evaluación médica previa.",
        },
        {
          title: "4. Conducta y Respeto en el Tatami",
          content: "Fomentamos el respeto mutuo, la disciplina, la seguridad y la integridad. Comportamientos antideportivos, imprudentes, agresivos o discriminatorios resultarán en la suspensión inmediata del acceso a los entrenamientos y a la plataforma.",
        },
        {
          title: "5. Propiedad Intelectual",
          content: "Todas las marcas, metodologías, logotipos, contenidos pedagógicos, textos, fotografías, videos y códigos vinculados a Executive Jiu-Jitsu y al Profesor Vagner Lima son propiedad exclusiva y están protegidos por las leyes de propiedad intelectual.",
        },
        {
          title: "6. Cancelación y Modificaciones",
          content: "Nos reservamos el derecho de actualizar estos términos periódicamente para reflejar mejoras o cambios normativos. El usuario puede solicitar el cierre y eliminación de su cuenta en cualquier momento.",
        },
        {
          title: "7. Legislación Aplicable y Jurisdicción",
          content: "Estos términos se rigen por las leyes de la República Federativa de Brasil. Para resolver cualquier controversia, se establece la jurisdicción de los tribunales de Palhoça / Florianópolis, Santa Catarina, Brasil.",
        },
      ],
    },
    dataDeletion: {
      title: "Eliminación de Cuenta y Datos Personales",
      subtitle: "Instrucciones claras y transparentes para solicitar la eliminación definitiva de su cuenta y datos personales, en estricto cumplimiento de Google Play y Apple Store.",
      overview: "Executive Jiu-Jitsu respeta su privacidad y su autonomía sobre sus datos. Si usted es alumno, tutor o usuario de nuestra aplicación y desea eliminar su cuenta y registros personales de nuestra base de datos, ponemos a su disposición canales directos y accesibles sin necesidad de mantener instalada la aplicación móvil.",
      howToTitle: "Cómo solicitar la eliminación de su cuenta:",
      steps: [
        {
          num: "01",
          title: "Complete el formulario web",
          desc: "Ingrese su nombre completo y el correo electrónico registrado en la aplicación o reservas.",
        },
        {
          num: "02",
          title: "Envío seguro de la solicitud",
          desc: "Envíe su petición directamente a través del formulario, por correo electrónico formal predeterminado o vía WhatsApp oficial.",
        },
        {
          num: "03",
          title: "Procesamiento y Confirmación",
          desc: "Nuestro equipo confirmará la recepción y ejecutará la eliminación de sus datos en un plazo máximo legal de hasta 15 días hábiles.",
        },
      ],
      tableTitle: "Detalle de retención y eliminación de datos:",
      tableHeaders: {
        category: "Tipo de Dato",
        action: "Acción de Eliminación",
        retention: "Retención / Justificación Legal",
      },
      tableRows: [
        {
          category: "Cuenta y Credenciales (login, contraseña, correo)",
          action: "Eliminados permanentemente",
          retention: "Supresión inmediata una vez confirmada la solicitud.",
        },
        {
          category: "Datos de Perfil (nombre, teléfono, cinturón, foto)",
          action: "Eliminados permanentemente",
          retention: "Borrados de forma irreversible de nuestros servidores activos.",
        },
        {
          category: "Historial de Asistencias y Clases Agendadas",
          action: "Anonimizados / Eliminados",
          retention: "Métricas históricas desvinculadas de cualquier identificador personal.",
        },
        {
          category: "Registros Fiscales y Comprobantes de Pago",
          action: "Retenidos por plazo legal",
          retention: "Conservados estrictamente durante el período exigido por la legislación fiscal brasileña (5 años), en entorno seguro y restringido.",
        },
      ],
      form: {
        title: "Formulario de Solicitud de Eliminación",
        desc: "Complete los campos siguientes para solicitar formalmente la eliminación de su cuenta y de todos sus datos personales asociados.",
        nameLabel: "Nombre completo",
        namePlaceholder: "Ingrese su nombre completo",
        emailLabel: "Correo electrónico registrado en la app",
        emailPlaceholder: "ejemplo@email.com",
        reasonLabel: "Motivo de la eliminación (opcional)",
        reasonPlaceholder: "Cuéntenos si hubo algún inconveniente o si simplemente desea cerrar su cuenta...",
        consentLabel: "Entiendo que la eliminación de mi cuenta es definitiva y borrará mi historial de entrenamientos y graduaciones.",
        submitEmailBtn: "Solicitar eliminación por Correo",
        submitWhatsappBtn: "Solicitar eliminación por WhatsApp",
        validationError: "Por favor, complete su nombre, un correo válido y confirme los términos.",
        successMsg: "¡Su solicitud ha sido preparada! Si la ventana de correo no se abrió automáticamente, también puede comunicarse con nosotros por WhatsApp haciendo clic en el botón a continuación.",
      },
    },
  },
};
